











import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { DocumentSearchPresetCondition, } from "../../../../domain/document";

@Component
export default class PresetDeleteArea extends Mixins() {
  @Prop()
  selectedPreset: DocumentSearchPresetCondition;

  @Emit()
  presetDeleted(): void {}

  data(): any {
    return {
      isProcessiong: false,
    };
  }
  isProcessiong: boolean;

  async deletePreset(): Promise<void> {
    try {
      this.isProcessiong = true;
      const repository = DomainRegistry.document.getDocumentRepository();
      await repository.deletePresetCondition(this.selectedPreset);
      this.presetDeleted();
      this.$success("プリセット削除成功", "プリセットの削除に成功しました。");
    } catch (e) {
      this.$error("プリセット削除失敗", "プリセットの削除に失敗しました。", e);
    } finally {
      this.isProcessiong = false;
    }
  }
}
